<template>
    <v-container class="bg-machine-game-surface-variant pa-0">
        <div class="keno-main-container">
            <div class="main-body" style="overflow:hidden">
                <div class="page-wrapper" style="overflow:hidden">
                    <div class="page-body" style="overflow:hidden">
                        <div class="lottery-menu-nav-head">
                            <MainMenu />
                        </div>
                        <SubmenuSport />
                        <div class="machine-game-body">
                            <img :src="require('~public_image/a_each_game/sport/sport_promo.jpg')" alt=""
                                class="w-100 h-100">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-container>
</template>

<script>

import SubmenuSport from "./component_sport/submenu-sport.vue";
import MainMenu from "../../../components/MainMenu.vue";

export default {

    components: {
        MainMenu,
        SubmenuSport
    },
    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        titleTemplate: `%s | Sport`
    },
};

</script>